import { render, staticRenderFns } from "./UserSetteiForm.vue?vue&type=template&id=06729378&scoped=true&"
import script from "./UserSetteiForm.vue?vue&type=script&lang=ts&"
export * from "./UserSetteiForm.vue?vue&type=script&lang=ts&"
import style0 from "./UserSetteiForm.vue?vue&type=style&index=0&id=06729378&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06729378",
  null
  
)

export default component.exports